import angular from 'angular';
import uiRouter from 'angular-ui-router';
import settingsComponent from './settings.component';

let settingsModule = angular.module('settings', [uiRouter])
  .config(($stateProvider) => {
    "ngInject";
    $stateProvider
      .state('settings', {
        url: '/settings',
        component: 'settings',
        resolve: {
          $title: () => 'Impostazioni'
        }
      });
  })
  .component('settings', settingsComponent)
  .name;

export default settingsModule;



// WEBPACK FOOTER //
// ./client/app/components/settings/settings.js